// Guarda, por tela, a última quantidade de linhas calculada dinamicamente para caber no
// container. Evita que toda listagem precise de duas requisições ao montar: uma com o valor
// padrão (chute) e outra corrigida assim que a altura real das linhas é medida.
const cache = new Map<string, number>();

export function getRowsPerPageCache(chave: string): number | undefined {
  return cache.get(chave);
}

export function setRowsPerPageCache(chave: string, valor: number): void {
  cache.set(chave, valor);
}
